// components/citationTypes/SeedFileViewer.tsx
import React from "react";
import { ImCross } from "react-icons/im";
import { Typography } from "@material-tailwind/react";
import ReactQuill from "react-quill";

interface Props {
  seedFileData: any;
  isLoading: boolean;
  error: string | null;
  onClose: () => void;
  formatDate: (dateString: string) => string | null;
}

const ExclusiveContentViewer: React.FC<Props> = ({ seedFileData, isLoading, error, onClose }) => {
  if (isLoading) {
    return (
      <div className="p-5 justify-center items-center h-full card_bg_color card_text_color">
        <ImCross onClick={onClose} className="cursor-pointer" />
        <div className="max-w-full animate-pulse">
          {[6, 4, 2, 2, 11, 11, 11, 11, 11].map((w, idx) => (
            <Typography key={idx} as="div" variant="paragraph" className={`mb-2 h-2 w-${w}/12 rounded-full bg-gray-500`}>
              &nbsp;
            </Typography>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-5 text-center font-bold card_bg_color h-full card_text_color">
        <ImCross onClick={onClose} className="cursor-pointer" />
        <h2>Oops, something went wrong.</h2>
      </div>
    );
  }

  if (seedFileData?.description) {
    // Remove all 'color' styles from the description's style attributes
    seedFileData.description = seedFileData.description.replace(
      /(<[^>]+style="[^"]*)color\s*:\s*[^;"]+;?([^"]*")/gi,
      (match: string, p1: string, p2: string) => {
        // Remove possible leftover semicolons and spaces
        let style = (p1 + p2).replace(/;\s*"/, '"').replace(/style="\s*;?/, 'style="');
        // If style attribute is now empty, remove it entirely
        return style === 'style=""' ? match.replace(/ style=""/, "") : style;
      }
    );
  }
  return (
    <div className="p-4 pb-20 card_bg_color h-full card_text_color">
      <ImCross onClick={onClose} className="cursor-pointer" />
      {seedFileData?.title && (
        <div className="flex mb-5 text-lg justify-center">
          <a href={seedFileData?.link} target="_blank" rel="noopener noreferrer" className="link_text_color">
            {seedFileData?.title}
          </a>
        </div>
      )}
      {seedFileData?.description && (
        <div className="mb-5 text-justify flex flex-col flex-1 overflow-hidden h-full">
          <h3 className="font-bold mb-2">Description:</h3>
          <div className="flex-1 overflow-auto text-white">
            <ReactQuill
              readOnly
              modules={{ toolbar: false }}
              value={seedFileData?.description}
              className="text-white"
              style={{ color: "white", height: "100%" }}
            />
          </div>
        </div>
      )}

      {seedFileData?.description && (
        <div className="mb-5 text-justify">
          <h3 className="font-bold">Description:</h3>
          <div className="overflow-auto text-white h-full">
            <ReactQuill
              readOnly
              modules={{ toolbar: false }}
              value={seedFileData?.description}
              className="text-white"
              style={{ color: "white" }}
            />
          </div>
        </div>
      )}
      {!seedFileData?.title && !seedFileData?.author && !seedFileData?.description && !seedFileData?.suggestion && (
        <div className="text-center font-bold">
          <h2>Source not found.</h2>
        </div>
      )}
    </div>
  );
};

export default ExclusiveContentViewer;
